var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"nothing-box flex-align"},[_c('div',{staticClass:"nothing-wrap"},[_c('img',{attrs:{"src":require("@/assets/common/nothing.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }